import { useState } from 'react';
import { useGlobal } from '../../context/GlobalContext';
import { getUiText } from '../../lib/uiText';
import styles from './CookieBanner.module.css';

const CookieBanner = () => {
  const { locale } = useGlobal();
  const [isVisible, setIsVisible] = useState(() => !localStorage.getItem('cookie-consent'));

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const content = {
    title: getUiText(locale, 'cookiesTitle'),
    body: getUiText(locale, 'cookiesBody'),
    button: getUiText(locale, 'accept'),
  };

  if (!content?.body) return null;

  return (
    <div className={styles['cookie-banner']} role="dialog" aria-live="polite">
      <div className={styles['cookie-banner__content']}>
        <div className={styles['cookie-banner__title']}>{content.title}</div>
        <p className={styles['cookie-banner__text']}>{content.body}</p>
      </div>
      <button type="button" className={styles['cookie-banner__button']} onClick={handleAccept}>
        {content.button}
      </button>
    </div>
  );
};

export default CookieBanner;
